module.exports = __webpack_public_path__ + "05_short_gray.ee9e01fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_short_gray.png
// module id = Fg07
// module chunks = 0